import React, { useEffect } from 'react';
import './Footer.css'

const Footer = () => {
  useEffect(() => {
    // Dynamically load the weather widget script when the component mounts
    const script = document.createElement('script');
    script.src = 'https://weatherwidget.io/js/widget.min.js';
    script.async = true;
    document.body.appendChild(script);

    // Clean up the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <> 
    <div className="footer-wrapper">
      <div className="footer-links">
          <ul>
            <li>&copy; 2026  Fifth Forest Engineering</li>
            <img
              src="/picz/icons/technology.png"
              alt="AI robot logo"
              className="brand-icon"
            />
          </ul>
        </div>
    </div>
    </>
  );
};

export default Footer;
